/* An alt text floor.

   ---- what used to be here, and why it is gone ------------------------

   This file also built a "Pause motion" button in the footer, for WCAG 2.2.2
   Pause, Stop, Hide. Sophie, 18 Oct: "the pause motion feature is giving us a
   ton of bugs, remove it."

   It was almost certainly the cause. Two things in combination:

     1. the choice was remembered in localStorage under 'aob-motion', so it
        survived page loads and sessions
     2. a capture-phase listener paused ANY video that tried to start while
        the flag was on, which was needed because aob-autoplay.js starts clips
        on scroll and would otherwise have undone the pause

   So one click, possibly by accident, left every video on every page frozen
   indefinitely with nothing on screen explaining why. That reads as the site
   being broken, not as a setting being on.

   The stored key is cleared below so it can never resurrect if the control
   is ever rebuilt.

   WHAT STILL HAPPENS: reduced-motion styles stop decorative motion and
   aob-a11y.css lets interface animations finish immediately, including
   popup animations that must complete to release scroll locks. This is
   automatic and does not persist a motion preference. What is gone is the
   manual control for everyone else, which means 2.2.2 is no longer fully met.
   The accessibility statement has been changed to say so rather than keep
   claiming a button that is not there.
   --------------------------------------------------------------------- */

(function () {
  // clear the old stored pause so it cannot come back
  try { localStorage.removeItem('aob-motion'); } catch (e) {}

  /* An image with no alt attribute at all is announced by a screen reader as
     its file name, which here means strings like
     "7ff0b833e685482997783507e7fc6fa2.thumbnail.jpg". An empty alt marks it
     decorative and it is skipped instead. Only images with NO alt attribute
     are touched, so real alt text is never overwritten. This is a floor, not
     a substitute for writing alt text on images that carry meaning. */
  function markDecorative() {
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDecorative);
  } else {
    markDecorative();
  }

  // app embeds inject images and markup well after load
  var mo = new MutationObserver(markDecorative);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
